module.exports = __webpack_public_path__ + "img/w1.ff4816dc.png";